import {
  ColDef,
  ColGroupDef,
  ICellRendererParams,
  ValueGetterParams,
} from "ag-grid-enterprise";
import { EditAndDeleteButtons } from "../../../../../../../shared/data-entries/EditAndDeleteButtons";
import { ManualAutoButton } from "../../../../../../../shared/data-entries/ManualAutoButton";
import { hasInjectorDoor } from "../../../../helpers/injection-helper";
import { CarbonInjection } from "../../../../models/eaf.models";

type Props = {
  editInjection: (injectionId: number) => void;
};

export const useTableData = ({ editInjection }: Props) => {
  const columns: ColGroupDef[] = [
    {
      headerName: "Injections",
      children: [
        {
          field: "manual-auto",
          headerName: " ",
          maxWidth: 40,
          flex: 1,
          cellRenderer: ManualAutoButton,
          cellRendererParams: (
            params: ICellRendererParams<CarbonInjection>,
          ) => ({
            isManual: (params.data as CarbonInjection).IsInjectionManual,
          }),
        },
        {
          field: "Type",
          headerName: "",
          flex: 1,
        },
        {
          field: "Injector1",
          headerName: "Inj 1",
          valueGetter: (params: ValueGetterParams<CarbonInjection>) => {
            return params?.data?.Injector1
              ? params.data.Injector1.toFixed(1)
              : "0";
          },
          flex: 1,
        },
        {
          field: "Injector2",
          headerName: "Inj 2",
          valueGetter: (params: ValueGetterParams<CarbonInjection>) => {
            return params?.data?.Injector2
              ? params.data.Injector2.toFixed(1)
              : "0";
          },
          flex: 1,
        },
        {
          field: "Injector3",
          headerName: "Inj 3",
          valueGetter: (params: ValueGetterParams<CarbonInjection>) => {
            return params?.data?.Injector3
              ? params.data.Injector3.toFixed(1)
              : "0";
          },
          flex: 1,
        },
        {
          field: "InjectorDoor",
          headerName: "Door",
          valueGetter: (params: ValueGetterParams<CarbonInjection>) => {
            const injection = params.data;

            if (!injection || !hasInjectorDoor(injection.Type)) {
              return "-";
            }

            return injection.InjectorDoor
              ? injection.InjectorDoor.toFixed(1)
              : "0";
          },
          flex: 1,
        },
        {
          field: "actions",
          headerName: " ",
          maxWidth: 40,
          flex: 1,
          cellRenderer: EditAndDeleteButtons,
          cellRendererParams: (
            params: ICellRendererParams<CarbonInjection>,
          ) => ({
            onEdit: editInjection,
            id: (params.data as CarbonInjection).InjectionTypeId,
          }),
        },
      ],
    },
  ];

  return { columns };
};
